module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<fieldset class="cw-fieldset cw-fileTranfer">\r\n    <form method="post" enctype="multipart/form-data" accept-charset="utf-8">\r\n        <div class="form-group mb-4">\r\n            <label class="cw-libelleEnrichi cw-required">'+
((__t=(UTILS.getSVGIcon("trombone", "", 16, null)))==null?'':__t)+
' '+
((__t=(i18n.t("common:uploadfile.fileSelectionLabel")))==null?'':__t)+
'</label>\r\n            <div class="more-input-files"></div>\r\n        </div>\r\n        <div class="form-group mb-4">\r\n            <label class="cw-libelleEnrichi">'+
((__t=(UTILS.getSVGIcon("bulle", "", 16, null)))==null?'':__t)+
' '+
((__t=(i18n.t("common:uploadfile.descriptionLabel")))==null?'':__t)+
'</label>\r\n            <textarea type="textarea" class="file-transfer-description form-control" name="description" value="" rows="4" tabindex="0"></textarea>\r\n        </div>\r\n        <div class="fil_transfer_btnBar"></div>\r\n        <span class="file-transfer-label"></span>\r\n        <input type="hidden" name="type_utilisation" value="" />\r\n        <input type="hidden" name="id_entite" value="" />\r\n    </form>\r\n</fieldset>';
}
return __p;
};
